// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.playerPopup {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.playerPopupContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding:32px 20px ;
}

.playerTitle {
  font-size: 20px;
  color: #C3D32C;
  text-align: center;
  margin-bottom: 24px;
}

.playerSubtitle {
  font-size: 14px;
  text-align: center;
  color: #888;
  margin-bottom: 20px;
}

.inputGroup {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.inputWithIcon {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
}

.inputWithIcon input,
.inputWithIcon select {
  width: 100%;
  padding: 10px 10px 10px 40px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
}

.inputWithIcon svg {
  position: absolute;
  left: 10px;
  color: #666;
}

.saveButton {
  width: 100%;
  padding: 15px;
  background-color: #C3D32C;
  color: #fff;
  font-size: 16px;
  text-align: center;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  margin-top: 24px;
}

.deleteButton {
  padding: 15px;
  color: red;
  background: none;
  font-size: 16px;
  text-align: center;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  margin-top: 24px;
  text-transform: uppercase;
}

.closeButton {
  color: #C3D32C;
  position: absolute;
  top: 8px;
  right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MonEquipe/PlayerPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;;AAEA;;EAEE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ","sourcesContent":[".playerPopup {\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  border-top-left-radius: 15px;\r\n  border-top-right-radius: 15px;\r\n  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1000;\r\n}\r\n\r\n.playerPopupContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding:32px 20px ;\r\n}\r\n\r\n.playerTitle {\r\n  font-size: 20px;\r\n  color: #C3D32C;\r\n  text-align: center;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.playerSubtitle {\r\n  font-size: 14px;\r\n  text-align: center;\r\n  color: #888;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.inputGroup {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.inputWithIcon {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n}\r\n\r\n.inputWithIcon input,\r\n.inputWithIcon select {\r\n  width: 100%;\r\n  padding: 10px 10px 10px 40px;\r\n  border-radius: 8px;\r\n  border: 1px solid #ccc;\r\n  font-size: 16px;\r\n}\r\n\r\n.inputWithIcon svg {\r\n  position: absolute;\r\n  left: 10px;\r\n  color: #666;\r\n}\r\n\r\n.saveButton {\r\n  width: 100%;\r\n  padding: 15px;\r\n  background-color: #C3D32C;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  border-radius: 50px;\r\n  border: none;\r\n  cursor: pointer;\r\n  margin-top: 24px;\r\n}\r\n\r\n.deleteButton {\r\n  padding: 15px;\r\n  color: red;\r\n  background: none;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  border-radius: 50px;\r\n  border: none;\r\n  cursor: pointer;\r\n  margin-top: 24px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.closeButton {\r\n  color: #C3D32C;\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
